var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip"
  }, [(_vm.isResponse === false) ? _c('Tooltip', {
    attrs: {
      "placement": _vm.placement,
      "content": _vm.content,
      "theme": _vm.theme,
      "max-width": "300"
    }
  }, [_vm._t("content", null, {
    "slot": "content"
  }), _vm._v(" "), (_vm.showIcon) ? _c('Icon', {
    attrs: {
      "type": "ios-help-circle"
    }
  }) : _c('div', [_vm._t("text")], 2)], 2) : _c('Icon', {
    attrs: {
      "type": "ios-help-circle"
    },
    on: {
      "click": _vm.response
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b334aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseTooltip/index.vue
// module id = yeaI
// module chunks = 142